// helper functions to store items whether in the browser local storage or in the office context settings depending
// on the context

export function getItem(itemName) {
  let itemValue

  if (window.Office) {
    itemValue = window.Office.context.document.settings.get(itemName)
    console.log("PPT GET " + itemName + " = " + itemValue)
  } else {
    itemValue = localStorage.getItem(itemName)
  }

  if (itemValue) {
    return JSON.parse(itemValue)
  }

  return null
}

export function setItem(item) {
  item.value = JSON.stringify(item.value)

  if (window.Office) {
    window.Office.context.document.settings.set(item.name, item.value)
    window.Office.context.document.settings.saveAsync((asyncResult) => {
      if (asyncResult.status == window.Office.AsyncResultStatus.Failed) {
        console.warn(item.name + " save failed. Error: " + asyncResult.error.message)
      } else {
        console.log(item.name + " : " + item.value + " saved.")
      }
    })
    return
  }
  localStorage.setItem(item.name, item.value)
}
